// extracted by mini-css-extract-plugin
export default {"socials":"HeaderSocials_socials__foD3L"};